<template>
    <div id="awaitingTickets">
        <supsis-table
            :columns="columns()"
            :rows="waitingChatGetter"
            :bottom-pagination="true"
            :pagination-cursor="paginationCursor"
            @cursor-changed="(cursor) => (paginationCursor = cursor)"
            :options="tableOptions"
        >
        </supsis-table>
        <AwaitingTicketDetails
            v-if="showingTicket"
            :ticket="showingTicket"
            @close="showingTicket = null"
            @confirm="sendResponse"
            @sendAsComment="sendAsComment"
            @deleteComment="deleteComment"
            @changeHideStatusIGComment="changeHideStatusIGComment"
            :statusList="statuses"
            :change-ticket-status="handleChangeStatus"
        />
    </div>
</template>

<script>
import Pagination from "../../../../components/Pagination.vue";
import ActionEdit from "../../../../components/svg/ActionEdit.vue";
import { mapActions, mapGetters, mapState } from "vuex";
import { log2 } from "../../../../utils/log2";
import { getPersistenceData } from "../../../../utils/persistenceStorage";
import { addTicketStatus } from "../../../../api/ticket";
import systemPubSub from "../../../../utils/systemPubSub";
import { filter } from "rxjs/operators";
import { PERMISSION_TYPES } from "../../../../language/permissionTypes";

import AwaitingTicketDetails from "./AwaitingTicketDetails.vue";
import { sendSocketMessage } from "../../../../utils/socketStream";
import SupsisTable from "../../../../components/SupsisTable.vue";
import SupsisButton from "../../Settings/components/SupsisButton.vue";
import _ from "lodash";

const log = log2("AwaitingTickets");
export default {
    name: "AwaitingTickets",
    components: {
        SupsisButton,
        SupsisTable,
        Pagination,
        ActionEdit,
        AwaitingTicketDetails,
    },
    props: {
        tag: { type: String },
        platform: { type: String },
        statuses: { type: Array },
        showMyTickets: { type: Boolean },
    },
    data() {
        return {
            page: 1,
            perPage: !isNaN(getPersistenceData("ticket-page-size") || "undefined")
                ? parseInt(getPersistenceData("ticket-page-size"))
                : 10,
            currentSort: {
                columnKey: "createdDate",
                order: "ascend",
            },
            pageSizes: ["10", "25", "50", "100"],
            columns: () => [
                {
                    title: this.$t("headBar.email"),
                    field: "email",
                    key: "email",
                    renderBodyCell: ({ row }) => {
                        return this.getVisitorValue(row, "email");
                    },
                },
                {
                    title: this.$t("headBar.phone"),
                    field: "phone",
                    key: "phone",
                    renderBodyCell: ({ row }) => {
                        return this.getVisitorValue(row, "phone");
                    },
                },
                {
                    title: this.$t("headBar.name"),
                    field: "name",
                    key: "name",
                    renderBodyCell: ({ row }) => {
                        return !!row.conversation
                            ? row.conversation.fullname || "-"
                            : !!row.osrPayload
                            ? row.osrPayload.fullname
                            : "-";
                    },
                },
                {
                    title: this.$t("headBar.date"),
                    field: "createdDate",
                    key: "createdDate",
                    renderBodyCell: ({ row }) => {
                        return this.$options.filters.date(row.createdDate);
                    },
                },
                {
                    title: this.$t("headBar.subject"),
                    field: "tag",
                    key: "tag",
                    copyDisabled: true,
                },
                {
                    title: this.$t("headBar.situation"),
                    field: "status",
                    key: "status",
                    copyDisabled: true,
                    width: 150,
                    renderBodyCell: ({ row }) => {
                        const renderOptions = () =>
                            this.statuses.map((status) => (
                                <a-select-option key={status._id} value={status.title}>
                                    {status.title}
                                </a-select-option>
                            ));

                        return (
                            <a-select
                                default-value={!!row.status ? row.status : null}
                                class="ticket-select"
                                on-change={(value) => this.handleChangeStatus(row._id, value)}
                            >
                                {renderOptions()}
                            </a-select>
                        );
                    },
                },
                {
                    title: this.$t("headBar.representative"),
                    field: "assignedUser",
                    key: "assignedUser",
                    copyDisabled: true,
                    width: 150,
                    renderBodyCell: ({ row }) => {
                        const renderOptions = () =>
                            this.users.data.map((user) => (
                                <a-select-option key={user._id} value={user._id}>
                                    {user.name}
                                </a-select-option>
                            ));
                        return (
                            <a-select
                                default-value={row.assignedUser ? row.assignedUser._id : null}
                                class="ticket-select"
                                on-change={(value) => this.handleChange(value, row._id)}
                            >
                                {renderOptions()}
                            </a-select>
                        );
                    },
                },
                {
                    title: this.$t("message.transactions"),
                    field: "_id",
                    key: "_id",
                    copyDisabled: true,
                    renderBodyCell: ({ row }) => {
                        return (
                            <div class="ticket-transactions">
                                {this.checkPermission(PERMISSION_TYPES["offlineSupportRequest.update"].tr.name) && (
                                    <a-button
                                        class="btnAction"
                                        on-click={() => this.view(row)}
                                        v-tippy={{ followCursor: true, placement: "bottom-end" }}
                                        content={this.$t("message.sendResponse")}
                                    >
                                        <ActionEdit />
                                    </a-button>
                                )}
                                {this.checkPermission(PERMISSION_TYPES["offlineSupportRequest.delete"].tr.name) && (
                                    <a-button
                                        class="btnAction"
                                        on-click={() => this.archived(row)}
                                        v-tippy={{ followCursor: true, placement: "bottom-end" }}
                                        content={this.$t("message.archived")}
                                    >
                                        <md-icon style="color: #3fc5bd">inventory_2</md-icon>
                                    </a-button>
                                )}
                            </div>
                        );
                    },
                },
            ],
            assignedUser: null,
            unSubs: [],
            showingTicket: null,
            paginationCursor: {
                total: 0,
                page: 1,
                perPage: 10,
            },
            tableOptions: {
                eventCustomOption: {
                    bodyCellEvents: () => {
                        return {
                            dblclick: (event) => {
                                const columnIndex = event.target.cellIndex;
                                const column = this.columns()[columnIndex];
                                if (column.copyDisabled) {
                                    return;
                                }
                                let text = event.toElement.innerText;
                                let textArea = document.createElement("textarea");
                                textArea.value = text;
                                document.body.appendChild(textArea);
                                textArea.select();
                                document.execCommand("copy");
                                document.body.removeChild(textArea);
                                this.$message.success({
                                    content: this.$t("message.copiedClipboard"),
                                    duration: 2,
                                    key: "saved",
                                });
                            },
                        };
                    },
                },
            },
        };
    },
    computed: {
        PERMISSION_TYPES() {
            return PERMISSION_TYPES;
        },
        ...mapState({
            waitingTickets: (state) => state.ticket.waitingTickets,
            topics: (state) => state.ticket.topics,
            users: (state) => state.user.users,
            user: (state) => state.auth.user,
        }),
        ...mapGetters({
            waitingChatGetter: "ticket/getWaitingTickets",
            getUser: "user/getUser",
            checkPermission: "auth/checkPermission",
        }),
    },
    methods: {
        ...mapActions({
            fetchWaitingTickets: "ticket/fetchWaitingTickets",
            assignRepresentative: "ticket/assignRepresentative",
            getUsers: "user/getUsers",
            loadOldMessages: "chat/loadOldMessages",
            sendTicketResponse: "ticket/sendTicketResponse",
        }),
        getVisitorValue(item, field) {
            if (field === "email") log("getVisitorValue", item, field);
            let value = !!item.conversation
                ? item.conversation[field] || "-"
                : !!item.osrPayload
                ? item.osrPayload[field]
                : "-";
            if (item.createdByChatbot) {
                if (field === "email") {
                    value = item.visitorEmailAddress || value;
                }
                if (field === "phone") {
                    value = item.visitorPhoneNumber || value;
                }
            }
            return value;
        },
        handleChange(repId, _id) {
            this.assignRepresentative({ _id, repId });
        },
        handleChangeStatus(id, title) {
            log("handleChangeStatus", id, title);
            addTicketStatus({ id, title }).then((res) => {
                this.$message.success("Ticket Status has been updated.");
                this.showingTicket.status = title;
                this.getData();
            });
        },
        view(item) {
            this.showingTicket = item;
        },
        sendResponse({ selectedHistory, responseText, senderMailId, resolved }) {
            console.log("sendResponse AwaitingTickets.vue..", { selectedHistory, responseText, senderMailId, resolved });
            console.log("resolved değeri:", resolved, "typeof:", typeof resolved);

            const customerEmail = selectedHistory.ticket.visitorEmailAddress ||
                                selectedHistory.ticket.visitor?.email ||
                                selectedHistory.ticket.osrPayload?.email;

            let data = {
                _id: selectedHistory.ticket._id,
                repId: this.user._id,
                customerEmail: customerEmail,
                response: responseText,
                senderMailId,
                resolved,
            };
            this.sendTicketResponse(data).then((x) => {
                this.showingTicket = null;
            });
        },
        sendAsComment({ selectedHistory, responseText, isPrivate }) {
            let data = {
                _id: selectedHistory.ticket._id,
                repId: this.user._id,
                response: responseText,
            };
            this.sendTicketResponse(data).then((x) => {
                const channelId =
                    _.get(selectedHistory, "visitor.channel._id") ||
                    _.get(selectedHistory, "conversation.visitor.channel._id");
                if (selectedHistory.ticket.type === "instagram-mention") {
                    sendSocketMessage("meta reply-mention", {
                        siteId: selectedHistory.ticket.siteId,
                        channelId,
                        commentId: selectedHistory.ticket.metaComment.commentId,
                        mediaId: selectedHistory.ticket.metaComment.payload.media_id,
                        message: responseText,
                        isPrivate,
                        type: selectedHistory.ticket.type,
                    });
                } else {
                    sendSocketMessage("meta reply-comment", {
                        siteId: selectedHistory.ticket.siteId,
                        channelId,
                        commentId: selectedHistory.ticket.metaComment.commentId,
                        message: responseText,
                        isPrivate,
                        type: selectedHistory.ticket.type,
                    });
                }

                this.showingTicket = null;
            });
        },
        deleteComment({ selectedHistory, responseText }) {
            let data = {
                _id: selectedHistory.ticket._id,
                repId: this.user._id,
                response: responseText,
            };
            const channelId =
                _.get(selectedHistory, "visitor.channel._id") ||
                _.get(selectedHistory, "conversation.visitor.channel._id");
            this.sendTicketResponse(data).then((x) => {
                sendSocketMessage("meta delete-ig-comment", {
                    siteId: selectedHistory.ticket.siteId,
                    channelId,
                    commentId: selectedHistory.ticket.metaComment.commentId,
                });
                this.$message.success("The instagram comment has been deleted from your IG post.");

                this.showingTicket = null;
            });
        },
        changeHideStatusIGComment({ selectedHistory, hide }) {
            if (selectedHistory.ticket.type !== "instagram-mention") {
                const channelId =
                    _.get(selectedHistory, "visitor.channel._id") ||
                    _.get(selectedHistory, "conversation.visitor.channel._id");
                sendSocketMessage("meta change-hide-status-of-ig-comment", {
                    siteId: selectedHistory.ticket.siteId,
                    channelId,
                    commentId: selectedHistory.ticket.metaComment?.commentId,
                    hide,
                });
                this.$message.success("The instagram comment hide status has been changed.");
            }
        },
        archived(item) {
            let data = {
                _id: item._id,
                repId: this.user._id,
                response: `Archived by ${this.user.name}`,
            };
            this.sendTicketResponse(data);
        },
        toggleSortOrder(columnKey) {
            if (this.currentSort.columnKey === columnKey) {
                this.currentSort.order = this.currentSort.order === "ascend" ? "descend" : "ascend";
            } else {
                this.currentSort.columnKey = columnKey;
                this.currentSort.order = "ascend";
            }
        },
        getData() {
            this.fetchWaitingTickets({
                page: this.paginationCursor.page,
                perPage: this.paginationCursor.perPage,
                tag: this.tag,
                assignedUser: this.assignedUser,
                platform: this.platform,
            }).then((res) => {
                const { tickets, totalPages, total, currentPage } = res?.data || { Ï };
                this.paginationCursor.total = total;
            });
        },
    },
    mounted() {
        this.toggleSortOrder("createdDate");
        this.getData();
        const newTicketSub = systemPubSub.stream.pipe(filter((x) => x.type === "ticket_message")).subscribe((x) => {
            this.getData();
        });
        this.unSubs.push(() => newTicketSub.unsubscribe());
        this.getUsers({
            page: 1,
            perPage: 1000,
        });
    },
    beforeDestroy() {
        this.unSubs.forEach((sub) => sub());
        clearInterval(this.refreshTimerId);
    },
    watch: {
        paginationCursor: {
            deep: true,
            handler(newVal, oldVal) {
                this.getData();
            },
        },
        tag() {
            this.getData();
        },
        platform() {
            this.getData();
        },
        showMyTickets(newValue) {
            if (newValue) {
                this.assignedUser = this.user._id;
                this.getData();
            } else {
                this.assignedUser = null;
                this.getData();
            }
        },
    },
};
</script>

<style lang="scss">
#awaitingTickets {
    .ticket-transactions {
        display: flex;
        gap: 10px;
        align-items: center;

        .btnAction {
            background: none;
            border: none;
        }
    }

    .ticket-select {
        width: 100%;

        .ant-select-selection {
            border-color: transparent !important;
        }
    }

    .custom-table {
        background-color: #ffffff;
        border-radius: 6px;
        padding: 10px 20px;
    }

    .ant-table-column-sorters,
    .ant-table-header-column {
        width: 100%;
    }

    .ant-table-header-column {
        padding: 0 10px;
    }

    .table-custom,
    .ant-table-placeholder,
    .ant-table-small {
        border: none;
    }

    .ant-table-thead tr {
    }

    .ant-table-body {
        tr {
        }

        td {
            padding: 0 8px !important;
            font-size: 12px;
            font-weight: 300;
            color: #181c32;
            border-bottom: none;
        }

        th {
            border-right: 1px solid #ebedf3;
            border-bottom: none;
            padding: 0 !important;

            &:last-child {
                border-right: none;
            }
        }
    }

    .ant-table-body tbody td {
        border-right: 1px solid #ebedf3;

        &:last-child {
            border-right: none;
        }
    }

    .ant-table-column-title {
        color: #181c32;
        font-size: 13px;
        font-weight: 300;
        font-family: Poppins;
        white-space: nowrap;
    }

    .actionButton {
        border: none;
        box-shadow: none;
    }
}

.userInfo {
    font-family: Poppins;

    &.first {
        color: #3699ff;
        font-size: 16px;
        font-weight: 500;
        padding-top: 15px;
        line-height: 1;
    }

    &.sec {
        color: #181c32;
        font-size: 14px;
        font-weight: 300;
    }
}

.waiting-ticket-messages {
    max-height: 550px !important;
    overflow: scroll;
}

//#awaiting-message-details {
//    .ant-modal {
//        width: 910px !important;
//    }
//}

#ticket-response {
    .actions {
        display: flex;
        justify-content: flex-end;
        gap: 10px;
        margin-top: 5px;
        padding: 5px;
        border-top: 1px solid var(--color-border-default);
    }
}
</style>
